/**
 * Tradier has a limit of 1250 symbols in their WS stream. If a tradeplan causes that the size of the stream to go over that 
 * limit, this notification arrises.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645459180475,
	"notificationDetails": {"errorType":"SYSTEM_ERROR","notificationType":"ERROR"},
	"status": "TOO_MANY_SYMBOLS",
	"statusDetails": {"previousCount":25,"newCount":50,"limit":12},
	"date": "2022-02-21T10:59:41.262-0500",
	"timestamp": "1645459181262"
}

 * @param {*} statusDetails 
 * @returns an object with following fields:
 * 1) previousCount: symbol size before the latest set of symbols is added
 * 2) newCount: symbol size after the latest set of symbols is added
 * 3) limit: the max amount of symbols that can be put in the stream 
 */
export function tooManySymbolsParser(statusDetails) {
  const parsedObj = {
    previousCount: null,
    newCount: null,
    limit: null,
  };
  if (statusDetails) {
    parsedObj.previousCount = statusDetails.previousCount ?? null;
    parsedObj.newCount = statusDetails.newCount ?? null;
    parsedObj.limit = statusDetails.limit ?? null;
  }

  return parsedObj;
}
